import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Triangle = function Triangle(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2.3902 18.0983 10.615 3.8917c.4545-.7852.6818-1.1777.9784-1.3096a1 1 0 0 1 .8126 0c.2965.1319.5238.5244.9783 1.3096l8.2249 14.2066c.4562.788.6843 1.182.6506 1.5054a1 1 0 0 1-.4065.7051c-.263.1912-.7182.1912-1.6288.1912H3.7749c-.9106 0-1.3658 0-1.6288-.1912a1 1 0 0 1-.4065-.7051c-.0337-.3234.1944-.7174.6506-1.5054"
    })
  }));
};
export default Triangle;